/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AllocationRuleCreateDataRequest
} from '../../model/allocationRuleCreateDataRequest'
import type {
  AllocationRuleEditDataRequest
} from '../../model/allocationRuleEditDataRequest'
import type {
  AllocationRuleInvestingEntitiesData
} from '../../model/allocationRuleInvestingEntitiesData'
import type {
  AllocationRuleListParams
} from '../../model/allocationRuleListParams'
import type {
  AllocationRuleReadData
} from '../../model/allocationRuleReadData'
import type {
  AllocationRuleReadDataList
} from '../../model/allocationRuleReadDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Returns a list of allocation rules
 */
export const allocationRuleList = (
    fundFamilyId: string,
    params?: AllocationRuleListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleReadDataList>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAllocationRuleListQueryKey = (fundFamilyId: string,
    params?: AllocationRuleListParams,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule/`, ...(params ? [params]: [])] as const;
    }

    
export const getAllocationRuleListQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleList>>, TError = unknown>(fundFamilyId: string,
    params?: AllocationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleList>>> = ({ signal }) => allocationRuleList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleListQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleList>>>
export type AllocationRuleListQueryError = unknown

export const useAllocationRuleList = <TData = Awaited<ReturnType<typeof allocationRuleList>>, TError = unknown>(
 fundFamilyId: string,
    params?: AllocationRuleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleList>>, TError = unknown>(fundFamilyId: string,
    params?: AllocationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleList>>> = ({ signal }) => allocationRuleList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleList>>>
export type AllocationRuleListSuspenseQueryError = unknown

export const useAllocationRuleListSuspense = <TData = Awaited<ReturnType<typeof allocationRuleList>>, TError = unknown>(
 fundFamilyId: string,
    params?: AllocationRuleListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleListLoader = (queryParamsOrFn?: (AllocationRuleListParams | ((params: Params) => AllocationRuleListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleListQueryKey(fundFamilyId, queryParams),
              queryFn: () => allocationRuleList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a new allocation rule
 */
export const allocationRuleCreate = (
    fundFamilyId: string,
    allocationRuleCreateDataRequest: AllocationRuleCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationRuleReadData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationRuleCreateDataRequest
    },
      options);
    }
  


export const getAllocationRuleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleCreate>>, TError,{fundFamilyId: string;data: AllocationRuleCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleCreate>>, TError,{fundFamilyId: string;data: AllocationRuleCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleCreate>>, {fundFamilyId: string;data: AllocationRuleCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  allocationRuleCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleCreate>>>
    export type AllocationRuleCreateMutationBody = AllocationRuleCreateDataRequest
    export type AllocationRuleCreateMutationError = unknown

    export const useAllocationRuleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleCreate>>, TError,{fundFamilyId: string;data: AllocationRuleCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a specific allocation rule
 */
export const allocationRuleRetrieve = (
    fundFamilyId: string,
    allocationRuleId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleReadData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/`] as const;
    }

    
export const getAllocationRuleRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleRetrieveQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleRetrieve>>> = ({ signal }) => allocationRuleRetrieve(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleRetrieve>>>
export type AllocationRuleRetrieveQueryError = unknown

export const useAllocationRuleRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleRetrieveQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleRetrieveQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleRetrieve>>> = ({ signal }) => allocationRuleRetrieve(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleRetrieve>>>
export type AllocationRuleRetrieveSuspenseQueryError = unknown

export const useAllocationRuleRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleRetrieveQueryKey(fundFamilyId,allocationRuleId),
              queryFn: () => allocationRuleRetrieve(fundFamilyId,allocationRuleId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edits a specific allocation rule
 */
export const allocationRuleUpdate = (
    fundFamilyId: string,
    allocationRuleId: string,
    allocationRuleEditDataRequest: AllocationRuleEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationRuleReadData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: allocationRuleEditDataRequest
    },
      options);
    }
  


export const getAllocationRuleUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleUpdate>>, TError,{fundFamilyId: string;allocationRuleId: string;data: AllocationRuleEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleUpdate>>, TError,{fundFamilyId: string;allocationRuleId: string;data: AllocationRuleEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleUpdate>>, {fundFamilyId: string;allocationRuleId: string;data: AllocationRuleEditDataRequest}> = (props) => {
          const {fundFamilyId,allocationRuleId,data} = props ?? {};

          return  allocationRuleUpdate(fundFamilyId,allocationRuleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleUpdate>>>
    export type AllocationRuleUpdateMutationBody = AllocationRuleEditDataRequest
    export type AllocationRuleUpdateMutationError = unknown

    export const useAllocationRuleUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleUpdate>>, TError,{fundFamilyId: string;allocationRuleId: string;data: AllocationRuleEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a specific allocation rule
 */
export const allocationRuleDestroy = (
    fundFamilyId: string,
    allocationRuleId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAllocationRuleDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleDestroy>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleDestroy>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleDestroy>>, {fundFamilyId: string;allocationRuleId: string}> = (props) => {
          const {fundFamilyId,allocationRuleId} = props ?? {};

          return  allocationRuleDestroy(fundFamilyId,allocationRuleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleDestroy>>>
    
    export type AllocationRuleDestroyMutationError = unknown

    export const useAllocationRuleDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleDestroy>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Activates an allocation rule
 */
export const allocationRuleActivate = (
    fundFamilyId: string,
    allocationRuleId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/activate/`, method: 'PATCH'
    },
      options);
    }
  


export const getAllocationRuleActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleActivate>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleActivate>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleActivate>>, {fundFamilyId: string;allocationRuleId: string}> = (props) => {
          const {fundFamilyId,allocationRuleId} = props ?? {};

          return  allocationRuleActivate(fundFamilyId,allocationRuleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleActivateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleActivate>>>
    
    export type AllocationRuleActivateMutationError = unknown

    export const useAllocationRuleActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleActivate>>, TError,{fundFamilyId: string;allocationRuleId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleActivateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a list of investing allocation rule edges for a given allocation rule
 */
export const allocationRuleInvestingEntitiesRetrieve = (
    fundFamilyId: string,
    allocationRuleId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleInvestingEntitiesData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/investing/`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleInvestingEntitiesRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/investing/`] as const;
    }

    
export const getAllocationRuleInvestingEntitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleInvestingEntitiesRetrieveQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>> = ({ signal }) => allocationRuleInvestingEntitiesRetrieve(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleInvestingEntitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>>
export type AllocationRuleInvestingEntitiesRetrieveQueryError = unknown

export const useAllocationRuleInvestingEntitiesRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleInvestingEntitiesRetrieveQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleInvestingEntitiesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleInvestingEntitiesRetrieveQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>> = ({ signal }) => allocationRuleInvestingEntitiesRetrieve(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleInvestingEntitiesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>>
export type AllocationRuleInvestingEntitiesRetrieveSuspenseQueryError = unknown

export const useAllocationRuleInvestingEntitiesRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleInvestingEntitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleInvestingEntitiesRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleInvestingEntitiesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleInvestingEntitiesRetrieveQueryKey(fundFamilyId,allocationRuleId),
              queryFn: () => allocationRuleInvestingEntitiesRetrieve(fundFamilyId,allocationRuleId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns all versions of an allocation rule as a table
 */
export const allocationRuleVersionList = (
    fundFamilyId: string,
    allocationRuleId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/versions/`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleVersionListQueryKey = (fundFamilyId: string,
    allocationRuleId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule/${allocationRuleId}/versions/`] as const;
    }

    
export const getAllocationRuleVersionListQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleVersionList>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleVersionListQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleVersionList>>> = ({ signal }) => allocationRuleVersionList(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleVersionListQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleVersionList>>>
export type AllocationRuleVersionListQueryError = unknown

export const useAllocationRuleVersionList = <TData = Awaited<ReturnType<typeof allocationRuleVersionList>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleVersionListQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleVersionListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleVersionList>>, TError = unknown>(fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleVersionListQueryKey(fundFamilyId,allocationRuleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleVersionList>>> = ({ signal }) => allocationRuleVersionList(fundFamilyId,allocationRuleId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleVersionListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleVersionList>>>
export type AllocationRuleVersionListSuspenseQueryError = unknown

export const useAllocationRuleVersionListSuspense = <TData = Awaited<ReturnType<typeof allocationRuleVersionList>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleVersionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleVersionListSuspenseQueryOptions(fundFamilyId,allocationRuleId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleVersionListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleVersionListQueryKey(fundFamilyId,allocationRuleId),
              queryFn: () => allocationRuleVersionList(fundFamilyId,allocationRuleId),
            }).then(() => null);
          }
          return null;
        });
      